<div class="contents-area" (dragstart)="onDragstartBody($event)">
	<!-- 登録元商品情報 -->
  <div class="block-row">
    <div class="column-list">
      <label class="list-input-title">アイテムコード</label>
      <div class="list-input-content" style="width: 9rem;">
        <input type="text" readonly [(ngModel)]="kymw7402Model.itemCode">
      </div>
  
      <label class="list-input-title">商品案内用商品名</label>
      <div class="list-input-content">
        <input type="text" readonly style="width: 32rem;"
          [(ngModel)]="kymw7402Model.guideGoodsName">
      </div>
    </div>

    <div class="column-list">
      <label class="list-input-title">商品マスタ単価</label>
      <div class="list-input-content" style="width: 9rem;">
        <input type="text" readonly [(ngModel)]="kymw7402Model.masterPrice">
      </div>

      <label class="list-input-title">商品案内用規格名</label>
      <div class="list-input-content">
        <input type="text" readonly style="width: 22rem;"
          [(ngModel)]="kymw7402Model.guideStandardName">
      </div>
    </div>
  </div>

  <!-- 基本情報 -->
  <div class="basic-info">
    <h2>基本情報</h2>
    <div class="element-column">
      <div class="block-row">
        <div class="column-list" style="width: 424px;">
          <label class="list-input-title">注文コード</label>
          <div class="list-input-content catalog-input">
            <app-not-null-text-input id="txi_OrderNum" #txi_OrderNum [subid]="'txi_OrderNum'"
              [halfOnly]="true" [maxChars]="6" [displayCountField]="false" [forcedEnabledMode]="'true'"
              [(ngModel)]="kymw7402Model.orderNum" [disabled]="basicInfoALLDisabled" [restrict]="'[0-9]'">
            </app-not-null-text-input>
          </div>
        </div>

        <div class="column-list">
          <label class="list-input-title">注文数変更用注文コード</label>
          <div class="list-input-content catalog-input">
            <app-not-null-text-input id="txi_OrderChangeOrderNum" #txi_OrderChangeOrderNum [subid]="'txi_OrderChangeOrderNum'"
              [halfOnly]="true" [maxChars]="6" [displayCountField]="false" [forcedEnabledMode]="'true'"
              [(ngModel)]="kymw7402Model.orderChangeOrderNum" [disabled]="basicInfoALLDisabled" [restrict]="'[0-9]'">
            </app-not-null-text-input>
          </div>
        </div>

        <button class="btn-secondary" (click)="eventSetRememberOrderNum_CLICKHandler()"
          [disabled]="basicInfoALLDisabled || kymw7402Model.orderReceptionStartCatalog === '' || btnRememberOrderNumDisabled">注文コード自動付番</button>

        <app-checkbox-label #chk_IncreaseGoods id="chk_IncreaseGoods" [subid]="'chk_IncreaseGoods'"
          [label]="'増量商品'" [tabindex]="0" [(ngModel)]="kymw7402Model.increaseGoods" [disabled]="basicInfoALLDisabled" [forcedEnabledMode]="'true'">
        </app-checkbox-label>
      </div>

      <div class="block-row">
        <div class="column-list" style="width: 424px;">
          <label class="list-input-title">受注受付開始企画回</label>
          <div class="list-input-content catalog-input">
            <app-not-null-text-input id="tbx_OrderReceptionStartCatalog" #tbx_OrderReceptionStartCatalog 
              [restrict]="'[0-9]'" [maxChars]="8" [displayCountField]="false" 
              [halfOnly]="true" [restrict]="'[0-9]'"
              [(ngModel)]="kymw7402Model.orderReceptionStartCatalog" [disabled]="basicInfoALLDisabled"
              (change)="eventOrderReceptionStartCatalog_CHANGEHandler()" [forcedEnabledMode]="'true'">
            </app-not-null-text-input>
          </div>

          <label class="list-input-title">配達開始企画回</label>
          <div class="list-input-content catalog-input">
            <app-not-null-text-input id="tbx_DeliveryStartCatalog" #tbx_OrderReceptionStartCatalog 
              [restrict]="'[0-9]'" [maxChars]="8" [displayCountField]="false" 
              [halfOnly]="true" [restrict]="'[0-9]'"
              [(ngModel)]="kymw7402Model.deliveryStartCatalog" [disabled]="basicInfoALLDisabled" [forcedEnabledMode]="'true'">
            </app-not-null-text-input>
          </div>
        </div>

        <div class="column-list">
          <label class="list-input-title">受注受付終了企画回</label>
          <div class="list-input-content catalog-input">
            <app-not-null-text-input id="tbx_OrderReceptionEndCatalog" #tbx_OrderReceptionEndCatalog 
              [restrict]="'[0-9]'" [maxChars]="8" [displayCountField]="false" [halfOnly]="true"
              [(ngModel)]="kymw7402Model.orderReceptionEndCatalog" 
              [disabled]="basicInfoALLDisabled && disabledStatus.basicInfo.orderReceptionEndCatalog" [forcedEnabledMode]="'true'">
            </app-not-null-text-input>
          </div>

          <label class="list-input-title">配達終了企画回</label>
          <div class="list-input-content catalog-input">
            <app-not-null-text-input id="tbx_DeliveryEndCatalog" #tbx_DeliveryEndCatalog 
              [restrict]="'[0-9]'" [maxChars]="8" [displayCountField]="false" [halfOnly]="true"
              [(ngModel)]="kymw7402Model.deliveryEndCatalog" 
              [disabled]="basicInfoALLDisabled && disabledStatus.basicInfo.deliveryEndCatalog" [forcedEnabledMode]="'true'">
            </app-not-null-text-input>
          </div>
        </div>
      </div>

      <div class="block-row">
        <div class="column-list">
          <label class="list-input-title">配達サイクル区分</label>
          <div class="list-input-content" style="width: 18rem;">
            <app-code-combo-box id="cmb_DeliveryCycleDiv" #cmb_DeliveryCycleDiv [subid]="'cmb_DeliveryCycleDiv'"
              [codeDiv]="'ctp334'" [labelField]="'CodeName'" [autofocus]="true" [forcedEnabledMode]="'true'"
              [(ngModel)]="kymw7402Model.deliveryCycleDiv" [disabled]="basicInfoALLDisabled" [required]="true"
              (change)="eventDeliveryCycleDiv_CHANGEHandler();updateCategoryCodeDiv();">
            </app-code-combo-box>
          </div>
        </div>

        <div class="column-list"  style="width: 284px;">
          <label class="list-input-title">月毎配達回</label>
          <div class="list-input-content" style="width: 4rem;">
            <select [(ngModel)]="kymw7402Model.monthlyDeliveryTimes" 
              [disabled]="basicInfoALLDisabled" #cmb_MonthlyDeliveryTimes forcedEnabledMode="'true'">
              <option value=""></option>
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
            </select>
          </div>
        </div>

        <div class="column-list">
          <label class="list-input-title">商品企画担当区分</label>
          <div class="list-input-content" style="width: 10rem;">
            <app-code-combo-box id="cmb_GoodsCatalogDiv" #cmb_GoodsCatalogDiv [subid]="'cmb_GoodsCatalogDiv'"
              [codeDiv]="'ctp114'" [labelField]="'CodeName'"
              [(ngModel)]="kymw7402Model.goodsCatalogDiv" [disabled]="basicInfoALLDisabled" [required]="true" [forcedEnabledMode]="'true'">
            </app-code-combo-box>
          </div>
        </div>

        <div class="column-list">
          <label class="list-input-title">休止グループコード</label>
          <div class="list-input-content" style="width: 2rem;">
            <input type="text" class="text-label-required" 
              plessInputTextSub  [disabled]="basicInfoALLDisabled" [maxlength]="1" 
              [halfOnly]="true" [restrict]="'[A-Z]'" [(ngModel)]="kymw7402Model.pauseGroupCode">
          </div>
        </div>
      </div>

      <div class="column-list">
        <label class="list-input-title">カテゴリコード</label>
        <div class="list-input-content" style="width: 18rem;">
          <app-code-combo-box [codeDiv]="'ctp338'" [labelField]="'codeValueName'" 
            id="cmb_RememberCategoryCode" #cmb_RememberCategoryCode [subid]="'cmb_RememberCategoryCode'" 
            [forcedEnabledMode]="'true'" [tabindex]="0" [(ngModel)]="kymw7402Model.rememberCategoryCode"
            [disabled]="basicInfoALLDisabled" [required]="btnDisplay == 'Approve'">
          </app-code-combo-box>
        </div>
      </div>
    </div>
  </div>

  <!-- 利用生協 -->
  <div>
    <h2>利用生協</h2>
    <div class="column-list">
      <label class="list-input-title">利用生協</label>
      <div class="list-input-content">
        <app-checkbox-label label="ALL" id="chk_AllCoop" #chk_AllCoop [forcedEnabledMode]="'true'"
          [tabindex]="0" [(ngModel)]="kymw7402Model.chk_all"
          [disabled]="basicInfoALLDisabled"
          (change)="eventAllCoop_CLICKHandler()"></app-checkbox-label>
        <app-checkbox-label label="い" id="chk_Seikyou1" [subid]="'chk_Seikyou1'" [tabindex]="0"
          [forcedEnabledMode]="'true'" [(ngModel)]="coopStatus['coop_ibaraki'].checked"
          [disabled]="coopStatus['coop_ibaraki'].disabled || basicInfoALLDisabled"
          (change)="eventSeikyou_CLICKHandler()"></app-checkbox-label>
        <app-checkbox-label label="と" id="chk_Seikyou2" [subid]="'chk_Seikyou2'" [tabindex]="0"
          [forcedEnabledMode]="'true'" [(ngModel)]="coopStatus['coop_tochigi'].checked"
          [disabled]="coopStatus['coop_tochigi'].disabled || basicInfoALLDisabled"
          (change)="eventSeikyou_CLICKHandler()"></app-checkbox-label>
        <app-checkbox-label label="ぐ" id="chk_Seikyou3" [subid]="'chk_Seikyou3'" [tabindex]="0"
          [forcedEnabledMode]="'true'" [(ngModel)]="coopStatus['coop_gunma'].checked"
          [disabled]="coopStatus['coop_gunma'].disabled || basicInfoALLDisabled"
          (change)="eventSeikyou_CLICKHandler()"></app-checkbox-label>
        <app-checkbox-label label="ち" id="chk_Seikyou4" [subid]="'chk_Seikyou4'" [tabindex]="0"
          [forcedEnabledMode]="'true'" [(ngModel)]="coopStatus['coop_chiba'].checked"
          [disabled]="coopStatus['coop_chiba'].disabled || basicInfoALLDisabled"
          (change)="eventSeikyou_CLICKHandler()"></app-checkbox-label>
        <app-checkbox-label label="さ" id="chk_Seikyou5" [subid]="'chk_Seikyou5'" [tabindex]="0"
          [forcedEnabledMode]="'true'" [(ngModel)]="coopStatus['coop_saitama'].checked"
          [disabled]="coopStatus['coop_saitama'].disabled || basicInfoALLDisabled"
          (change)="eventSeikyou_CLICKHandler()"></app-checkbox-label>
        <app-checkbox-label label="とう" id="chk_Seikyou6" [subid]="'chk_Seikyou6'" [tabindex]="0"
          [forcedEnabledMode]="'true'" [(ngModel)]="coopStatus['coop_tokyo'].checked"
          [disabled]="coopStatus['coop_tokyo'].disabled || basicInfoALLDisabled"
          (change)="eventSeikyou_CLICKHandler()"></app-checkbox-label>
        <app-checkbox-label label="な" id="chk_Seikyou7" [subid]="'chk_Seikyou7'" [tabindex]="0"
          [forcedEnabledMode]="'true'" [(ngModel)]="coopStatus['coop_nagano'].checked"
          [disabled]="coopStatus['coop_nagano'].disabled || basicInfoALLDisabled"
          (change)="eventSeikyou_CLICKHandler()"></app-checkbox-label>
        <app-checkbox-label label="に" id="chk_Seikyou8" [subid]="'chk_Seikyou8'" [tabindex]="0"
          [forcedEnabledMode]="'true'" [(ngModel)]="coopStatus['coop_niigata'].checked"
          [disabled]="coopStatus['coop_niigata'].disabled || basicInfoALLDisabled"
          (change)="eventSeikyou_CLICKHandler()"></app-checkbox-label>
      </div>
    </div>
  </div>

  <!-- 価格情報 -->
  <div>
    <h2>価格情報</h2>
    <div class="element-column">
      <wj-flex-grid #dtg_detailInfoList id="dtg_detailInfoList"
        [itemsSource]="kymw7402Model.detailInfoList" [allowDragging]="'None'" [allowSorting]="false" [selectionMode]="'Row'"
        [headersVisibility]="'Column'" horizontalScrollPolicy="on" [isReadOnly]="true" forcedEnabledMode="true"
        [tabindex]="0" [style.width.px]="1623" [style.height.px]="172"
        (click)="eventDetailInfoList_CLICKHandler($event, dtg_detailInfoList)">
        <wj-flex-grid-column [minWidth]="5" [header]="'適用開始企画回'" [width]="130" [binding]="'applicableStartCatalog'">
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'適用終了企画回'" [width]="130" [binding]="'applicableEndCatalog'">
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'配達休止'" [width]="90" [binding]="'pauseDelivery'">
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'値引単価'" [width]="90" [binding]="'discountUnitPrice'" [align]="'right'">
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'値引率'" [width]="90" [binding]="'discountRate'" [align]="'right'">
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'専用商品名'" [width]="270" [binding]="'rememberGoodsName'">
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'専用商品名(ｶﾅ)'" [width]="268" [binding]="'rememberGoodsNameKana'">
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'専用規格名'" [width]="270" [binding]="'rememberStandardName'">
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'専用規格名(ｶﾅ)'" [width]="268" [binding]="'rememberStandardNameKana'">
        </wj-flex-grid-column>
      </wj-flex-grid>

      <div class="element-column cost-info-input">
        <div class="block-row">
          <div class="column-list">
            <label class="list-input-title">適用開始企画回</label>
            <div class="list-input-content catalog-input">
              <input type="text"
                id="tbx_ApplicableStartCatalog" #tbx_ApplicableStartCatalog plessInputTextSub
                [restrict]="'[0-9]'" [halfOnly]="true" [maxlength]="8"
                [(ngModel)]="kymw7402Model.applicableStartCatalog" class="text-label-required"
                (change)="eventApplicableStartCatalog_CHANGEHandler()"
                [disabled]="detailInfoALLDisabled || disabledStatus.detailInfo.applicableStartCatalog" forcedEnabledMode="'true'">
            </div>
          </div>
    
          <div class="column-list">
            <label class="list-input-title">適用終了企画回</label>
            <div class="list-input-content catalog-input">
              <app-not-null-text-input id="tbx_ApplicableEndCatalog" #tbx_ApplicableEndCatalog
                [restrict]="'[0-9]'" [maxChars]="8" [displayCountField]="false" [halfOnly]="true"
                [(ngModel)]="kymw7402Model.applicableEndCatalog" [required]="true"
                [disabled]="detailInfoALLDisabled || disabledStatus.detailInfo.applicableEndCatalog" [forcedEnabledMode]="'true'">
              </app-not-null-text-input>
            </div>
          </div>
          
          <app-checkbox-label #chk_PauseDelivery id="chk_PauseDelivery" [subid]="'chk_PauseDelivery'"
            [label]="'配達休止'" [tabindex]="0" [(ngModel)]="kymw7402Model.pauseDelivery" 
            [disabled]="detailInfoALLDisabled || disabledStatus.detailInfo.pauseDelivery" [forcedEnabledMode]="'true'">
          </app-checkbox-label>
        </div>

        <div class="column-list">
          <label class="list-input-title">値引区分</label>
          <div class="list-input-content" style="width: 10rem;">
            <app-code-combo-box id="cmb_DiscountType" #cmb_DiscountType [subid]="'cmb_DiscountType'"
              [codeDiv]="'ctp112'" [labelField]="'codeValueName'" [blank]="false" [required]="true" [forcedEnabledMode]="'true'"
              [(ngModel)]="kymw7402Model.discountType" 
              [disabled]="detailInfoALLDisabled || disabledStatus.detailInfo.cmbDiscountType" 
              (change)="eventDiscountType_CHANGEHandler()">
            </app-code-combo-box>
          </div>
        </div>

        <div class="block-row">
          <div class="column-list">
            <label class="list-input-title">値引単価</label>
            <div class="list-input-content catalog-input">
              <app-text-input id="tbx_DiscountUnitPrice" #tbx_DiscountUnitPrice
                [restrict]="'[0-9]'" [maxChars]="7" [displayCountField]="false" [halfOnly]="true"
                [(ngModel)]="kymw7402Model.discountUnitPrice"
                (change)="eventDiscountUnitPrice_CHANGEHandler()"
                [disabled]="detailInfoALLDisabled || disabledStatus.detailInfo.discountUnitPrice" [forcedEnabledMode]="'true'">
              </app-text-input>
            </div>
          </div>

          <div class="column-list">
            <label class="list-input-title">値引率</label>
            <div class="list-input-content" style="width: 4rem;">
              <app-text-input id="tbx_DiscountRate" #tbx_DiscountRate
                [restrict]="'[0-9]'" [maxChars]="3" [displayCountField]="false" [halfOnly]="true"
                [(ngModel)]="kymw7402Model.discountRate"
                (change)="eventDiscountRate_CHANGEHandler()"
                [disabled]="detailInfoALLDisabled || disabledStatus.detailInfo.discountRate" [forcedEnabledMode]="'true'">
              </app-text-input>
            </div>
          </div>

          <div class="column-list">
            <label class="list-input-title">値引後供給単価</label>
            <div class="list-input-content catalog-input">
              <input type="text" readonly [(ngModel)]="kymw7402Model.discountPrice" forcedEnabledMode="'true'">
            </div>
          </div>
        </div>

        <div class="block-row">
          <div class="column-list">
            <label class="list-input-title">専用商品名</label>
            <div class="list-input-content" style="width: 17rem;">
              <app-not-null-text-input-coop-deli id="txi_RememberGoodsName" #txi_RememberGoodsName [subid]="'txi_RememberGoodsName'"
                [restrict]="'[ -￮]'" [maxChars]="15" [displayCountField]="false" [forcedEnabledMode]="'true'"
                [(ngModel)]="kymw7402Model.rememberGoodsName" 
                [disabled]="detailInfoALLDisabled || disabledStatus.detailInfo.rememberGoodsName" [fullOnly]="true">
              </app-not-null-text-input-coop-deli>
            </div>

            <label class="list-input-title">専用商品名(ｶﾅ)</label>
            <div class="list-input-content" style="width: 17rem;">
              <app-not-null-text-input id="txi_RememberGoodsNameKana" #txi_RememberGoodsNameKana [subid]="'txi_RememberGoodsNameKana'"
                [halfOnly]="true" [maxChars]="15" [displayCountField]="false" [forcedEnabledMode]="'true'"
                [(ngModel)]="kymw7402Model.rememberGoodsNameKana" 
                [disabled]="detailInfoALLDisabled || disabledStatus.detailInfo.rememberGoodsNameKana"
                (input)="eventRememberGoodsNameKana_deleteCommaHandler()"
                (compositionstart)="onCompStart()" (compositionend)="onCompDeleteCommaEnd($event)"
                [toUpperCase]="true">
              </app-not-null-text-input>
            </div>
          </div>

          <div class="column-list">
            <label class="list-input-title">専用規格名</label>
            <div class="list-input-content" style="width: 12rem;">
              <app-not-null-text-input-coop-deli id="txi_RememberStandardName" #txi_RememberStandardName [subid]="'txi_RememberStandardName'"
                [restrict]="'[ -￮]'" [maxChars]="10" [displayCountField]="false" [forcedEnabledMode]="'true'"
                [(ngModel)]="kymw7402Model.rememberStandardName" 
                [disabled]="detailInfoALLDisabled || disabledStatus.detailInfo.rememberStandardName" [fullOnly]="true">
              </app-not-null-text-input-coop-deli>
            </div>

            <label class="list-input-title">専用規格名(ｶﾅ)</label>
            <div class="list-input-content" style="width: 12rem;">
              <app-not-null-text-input id="txi_RememberStandardNameKana" #txi_RememberStandardNameKana [subid]="'txi_RememberStandardNameKana'"
                [halfOnly]="true" [maxChars]="10" [displayCountField]="false" [forcedEnabledMode]="'true'"
                [(ngModel)]="kymw7402Model.rememberStandardNameKana" 
                [disabled]="detailInfoALLDisabled || disabledStatus.detailInfo.rememberStandardNameKana"
                (input)="eventRememberStandardNameKana_deleteCommaHandler()"
                (compositionstart)="onCompStart()" (compositionend)="onCompDeleteCommaEnd($event)"
                [toUpperCase]="true">
              </app-not-null-text-input>
            </div>
          </div>
        </div>

        <div class="element-row row-btn">
          <div>
            <button class="btn-tartiary" #btn_ClearInput id="btn_ClearInput"
              (click)="eventClearInput_CLICKHandler()" 
              [disabled]="detailInfoALLDisabled && (isFixedDeliveryEndCatalog || isBeforeOldestDeliveryEndCatalog)">クリア</button>
          </div>

          <div>
            <button class="btn-secondary" #btn_AddRow id="btn_AddRow"
              (click)="eventAddRow_CLICKHandler()" 
              [disabled]="detailInfoALLDisabled || disabledStatus.detailInfo.addRow">行追加</button>
            <button class="btn-secondary" #btn_UpdateRow id="btn_UpdateRow"
              (click)="eventUpdateRow_CLICKHandler()" 
              [disabled]="detailInfoALLDisabled || dtg_detailInfoList.selection.row === -1 || disabledStatus.detailInfo.updateRow">行更新</button>
          </div>
        </div>
      </div>
    </div>

  </div>

</div>

<footer class="footer-buttons">
  <button class="btn-tartiary" id="btn_Back" (click)="eventBack_CLICKHandler()" forcedEnabledMode="'true'">忘れず注文商品一覧に戻る</button>
  <button class="btn-primary" id="btn_Regist" *ngIf="btnDisplay == 'Regist'"
    (click)="eventRegist_CLICKHandler()" [disabled]="btnRegistDisabled">登録</button>
  <button class="btn-primary" id="btn_Approve" *ngIf="btnDisplay == 'Approve'"
    (click)="eventApprove_CLICKHandler()" [disabled]="btnApproveDisabled">承認</button>
</footer>